import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { localsMessages } from '../../utility/getTemplateData';
import { DropdownMenu } from '@paypalcorp/pp-react-dropdown-menu';
import * as AppActions from '../../actions/AppActions';
import appStore from '../../stores/AppStore';
import { trackLinkClick } from '../../fpti/fpti';
import { FPTI_TAGS, LINK_NAME } from '../../fpti/fptiConstants';
const messages = localsMessages('common/programs');

const Programs = ({ programNames, isDisabled }) => {
  const [selectedIdx, handleSelect] = useState(0);

  const getProgramOptions = () => {
    const options = [];
    programNames.forEach((programName) => {
      options.push({
        primaryText: programName,
      });
    });

    return options;
  };

  const updateProgramId = (index) => {
    handleSelect(index);
    const selectedProgram = index === -1 ? '' : programNames[index];
    AppActions.updateSelectedProgram(selectedProgram);
    trackLinkClick(LINK_NAME.PROGRAM_SELECTED, {
      additionalData: {
        [FPTI_TAGS.CAMPAIGN]: selectedProgram,
      },
    });
  };

  useEffect(() => {
    let programOption = getProgramOptions().findIndex(
      (program) => program.primaryText === appStore.getSelectedProgram()
    );
    programOption = programOption === -1 ? 0 : programOption;
    handleSelect(programOption);
    AppActions.updateSelectedProgram(programNames[programOption]);
  }, []);

  return (
    <DropdownMenu
      id="programs"
      className="landing-programs"
      label={messages.programs.optional}
      data-testid="programs-drowpdown"
      options={getProgramOptions()}
      selectedItemIndex={selectedIdx}
      onSelection={updateProgramId}
      disabled={isDisabled || false}
    />
  );
};

Programs.propTypes = {
  programNames: PropTypes.array,
  isDisabled: PropTypes.bool,
};

export default Programs;
